import TD from 'thinkingdata-browser';

var config = {
    appId: "ec29541bfe41481f972264685c883496",
    // serverUrl: "https://web-wankang.xlhcq.com/",
    serverUrl: "https://ta.ysiyhua.cn",
    autoTrack: {
        pageShow: true, //开启页面展示事件，事件名ta_page_show
        pageHide: true, //开启页面隐藏事件，事件名ta_page_hide
    }
};
TD.init(config)
export default {
    TD
}